const SEARCH_HN_PAGE_CODES = ['page-search-hn', 'page-rpt-search-hn', 'page-search-patient']
const SEARCH_VN_PAGE_CODES = ['page-rpt-search-vn', 'search-pas-patient-vn']
const SEARCH_AN_PAGE_CODES = ['page-rpt-search-an', 'search-pas-an']

const replaceSearchAction = (value, pageCodes, title) => {
  if (Array.isArray(value)) {
    let changed = false
    const next = value.map((item) => {
      const result = replaceSearchAction(item, pageCodes, title)
      if (result !== item) changed = true
      return result
    })
    return changed ? next : value
  }

  if (!value || typeof value !== 'object') return value

  let changed = false
  const next = Object.keys(value).reduce((result, key) => {
    const item = replaceSearchAction(value[key], pageCodes, title)
    if (item !== value[key]) changed = true
    result[key] = item
    return result
  }, {})

  if (
    next.modalType === 'external' &&
    next.sourceType === 'page' &&
    pageCodes.includes(next.formCode)
  ) {
    return {
      ...next,
      modalType: 'component',
      component: next.formCode,
      title,
      modalSize: 'xl',
    }
  }

  return changed ? next : value
}

const useNativeDesignerSearch = (response, pageCodes, title) => {
  if (typeof window !== 'undefined' && /^#?\/designer\/(?!display\/)/.test(window.location.hash)) return response

  const url = response?.config?.url || ''
  if (!url.includes('/designer/form-design/getByCode?')) return response

  const jsonData = response?.data?.data?.jsonData
  if (!jsonData?.uischema) return response

  const uischema = replaceSearchAction(jsonData.uischema, pageCodes, title)
  if (uischema === jsonData.uischema) return response

  return {
    ...response,
    data: {
      ...response.data,
      data: {
        ...response.data.data,
        jsonData: { ...jsonData, uischema },
      },
    },
  }
}

export const useNativeDesignerSearchHn = (response) =>
  useNativeDesignerSearch(response, SEARCH_HN_PAGE_CODES, 'ค้นหา HN ผู้ป่วย')

export const useNativeDesignerSearchVn = (response) =>
  useNativeDesignerSearch(response, SEARCH_VN_PAGE_CODES, 'ค้นหา VN ผู้ป่วย')

export const useNativeDesignerSearchAn = (response) =>
  useNativeDesignerSearch(response, SEARCH_AN_PAGE_CODES, 'ค้นหา AN ผู้ป่วย')
